module.exports = __webpack_public_path__ + "img/197.2723cf31.jpg";